export default {
  styledFieldOuter: {
    align:'center',
    p:0
  },
  styledField:{
    br: 5,
    mb: 5
  },
  styledInput:{
    bs: 0,
    br: 3,
  },
  styledWrapper:{
    w:1,
  }
}


// WEBPACK FOOTER //
// ./src/static/style/StyleFormDefault/index.js